module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/single-tag/single-tag.component.scss
// module id = ./src/app/modules/common-module/components/single-tag/single-tag.component.scss
// module chunks = 9